import React from 'react'
import { observer } from "mobx-react-lite"
import './styles.css'
import { useNeomem } from '../application'

export default observer(() => {
  const neomem = useNeomem()
  return (
    <div className="view-profile">
      <div className="view-profile-title">
        PROFILE
      </div>
      <div>
        id: {neomem.user.id}
      </div>
      <div>
        name: {neomem.user.name}
      </div>
      <div>
        email: {neomem.user.email}
      </div>
    </div>
  )
})
